import { createTranslations } from '@npco/common-utils-translations'

export const lastModifiedTranslations = createTranslations({
  lastModifiedSummary:
    'Last Modified: {dayMonthAndYear} at {time} by {customerName}',
})
